import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { TicketActivityTabComponent } from '../ticket-activity-tab/ticket-activity-tab.component';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TicketService } from 'src/app/private/services/tickets.service';
import { MessageService } from 'primeng/api';
import { UploadService } from 'src/app/private/services/upload.service';

@Component({
  selector: 'app-ticket-middle-view',
  imports: [SharedModule, TicketActivityTabComponent],
  templateUrl: './ticket-middle-view.component.html',
  styleUrl: './ticket-middle-view.component.scss'
})
export class TicketMiddleViewComponent implements OnInit, OnChanges {

  @Input() ticket: any;
  currTabActiveId: any = "0";

  // Timeline data for the ticket
  ticketTimeline: any[] = [];

  // Loading state for activities
  isLoadingActivities: boolean = false;

  // Comment input
  newComment: string = '';

  // File attachment properties
  ticketAttachments: any[] = [];
  showImageViewer: boolean = false;
  showAddFileDialog: boolean = false;
  selectedAttachment: any = null;
  selectedFiles: File[] = [];
  savingAttachments: boolean = false;

  replyTo = 'Chetan Chumble (chetan.chumble@gravitas.ai)';
  replyMessage = `Hi Chetan ,
Thank you for contacting us. We sure can help you. Shall we schedule a call tomorrow around 12.00pm? We can help you better if we are on a call.
Please let us know your availability.
Thanks
Akshita Garg`;

  attachments = [
    {
      name: 'document.pdf',
      size: '1.2 MB',
      type: 'pdf'
    },
    {
      name: 'image.png',
      size: '500 KB',
      type: 'image'
    }
  ];

  constructor(
    private ticketService: TicketService,
    private localStorageService: LocalStorageService,
    private messageService: MessageService,
    private uploadService: UploadService
  ) { }

  ngOnInit() {
    // Initialize with some default timeline data
    this.initializeTimeline();
    // Initialize sample attachments
    this.initializeAttachments();
  }

  handleTabChange(event: any) {
    console.log('Tab changed:', event);
    this.currTabActiveId = event.value;
  }


  //  "ticket_id": 123,
  //   "organization_id": 1

  getTicketActivitiesData() {

    // Set loading state to true
    this.isLoadingActivities = true;

    const payload = {
      ticket_id: this.ticket?.ticket_id,
      organization_id: this.localStorageService.getOrganizationId()
    };

    this.ticketService.getTicketActivities(payload).subscribe({
      next: (response) => {

        console.log('Ticket activities response:', response);

        this.ticketTimeline = response.rows.map((activity: any) => ({
          name: `${activity.user?.fname ?? ''} ${activity.user?.lname ?? ''}`.trim() || 'Unknown User',
          date: new Date(activity.createdAt).toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          }),
          desc: activity.comment_text || 'No description provided'
        }));

        // revere the timeline to show latest activities first
        this.ticketTimeline.reverse();

        // Set loading state to false
        this.isLoadingActivities = false;
      },
      error: (error) => {
        console.error('Error fetching ticket activities', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load ticket activities. Please try again later.'
        });

        // Set loading state to false even on error
        this.isLoadingActivities = false;
      }
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['ticket'] && changes['ticket'].currentValue) {
    //   // Clear previous timeline data and reset loading state when ticket changes
    //   this.ticketTimeline = [];
    //   this.isLoadingActivities = false;
    //   this.initializeTimeline();
    // }
  }

  initializeTimeline() {
    if (this.ticket?.ticket_id) {
      this.getTicketActivitiesData();
    }
  }

  private loadTimelineFromAPI() {
    // TODO: Implement API call to load timeline
    /*
    if (this.ticket?.id) {
      this.ticketService.getTicketTimeline(this.ticket.id).subscribe({
        next: (response) => {
          if (response.success) {
            this.ticketTimeline = response.data;
          } else {
            this.createSampleTimeline();
          }
        },
        error: (error) => {
          console.error('Error loading timeline', error);
          this.createSampleTimeline();
        }
      });
    } else {
      this.createSampleTimeline();
    }
    */
  }


  onKeyDown(event: KeyboardEvent) {
    // Send comment on Enter key press (without Shift)
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevent adding a new line
      this.addComment();
    }
  }

  addComment() {
    if (!this.newComment || !this.newComment.trim()) {
      return;
    }

    // Create new timeline entry for the comment
    const newTimelineEntry = {
      name: this.localStorageService.getUserFullName() || 'Current User',
      date: new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }),
      desc: this.newComment.trim(),
      type: 'comment'
    };

    // Add to timeline
    this.ticketTimeline = [...this.ticketTimeline, newTimelineEntry];

    // Here you would make an API call to save the comment
    this.saveCommentToAPI(newTimelineEntry);

    // Clear the input
    this.newComment = '';
  }

  private saveCommentToAPI(comment: any) {

    //  "ticket_id": 123,
    // "comment_text": "This is a manual comment added to the ticket",
    // "source": "manual",
    // "user_id": 1,
    // "organization_id": 1

    const payload = {
      ticket_id: this.ticket.ticket_id,
      comment_text: comment.desc,
      source: 'manual',
      user_id: this.localStorageService.getUserId(),
      organization_id: this.localStorageService.getOrganizationId()
    };

    this.ticketService.addTicketComment(payload).subscribe({
      next: (response) => {
        console.log('Comment saved successfully', response);
        // Update the timeline entry with the returned ID
        const index = this.ticketTimeline.findIndex(item => item === comment);
        if (index !== -1) {
          this.ticketTimeline[index] = { ...comment, id: response.id };
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save comment. Please try again.'
        });
        console.error('Error saving comment', error);
        // Handle error - remove the comment from timeline or show error message
        this.ticketTimeline = this.ticketTimeline.filter(item => item !== comment);
        // Show error message to user
        // this.messageService.add({
        //   severity: 'error', 
        //   summary: 'Error', 
        //   detail: 'Failed to save comment. Please try again.'
        // });
      }
    });
  }

  initializeAttachments() {
    // Sample attachment data - in real app, this would come from the API
    this.ticketAttachments = this.ticket?.attachments || [];
  }



  closeImageViewer() {
    this.showImageViewer = false;
    this.selectedAttachment = null;
  }

  openInBrowser(attachment: any) {
    window.open(attachment.url, '_blank');
  }



  onFileSelect(event: any) {
    const files = event.files;

    for (let file of files) {
      // Create file object
      const newAttachment = {
        id: this.ticketAttachments.length + 1,
        name: file.name,
        type: this.getFileType(file.type),
        size: this.formatFileSize(file.size),
        url: URL.createObjectURL(file), // Temporary URL for preview
        uploadDate: new Date().toLocaleString(),
        uploadedBy: 'Current User' // In real app, get from auth service
      };

      this.ticketAttachments.push(newAttachment);

      // Add to timeline
      const timelineEntry = {
        name: 'Current User',
        date: new Date().toLocaleString(),
        desc: `Uploaded file: ${file.name}`,
        type: 'attachment'
      };
      this.ticketTimeline = [...this.ticketTimeline, timelineEntry];
    }

    this.showAddFileDialog = false;

    // Here you would upload files to server
    // this.uploadFilesToServer(files);
  }

  onFileInputChange(event: any) {
    const files: FileList = event.target.files;
    this.selectedFiles = Array.from(files);
  }

  removeSelectedFile(fileToRemove: File) {
    this.selectedFiles = this.selectedFiles.filter(file => file !== fileToRemove);
  }

  uploadSelectedFiles() {
    for (let file of this.selectedFiles) {
      // Create file object
      const newAttachment = {
        id: this.ticketAttachments.length + 1,
        name: file.name,
        type: this.getFileType(file.type),
        size: this.formatFileSize(file.size),
        url: URL.createObjectURL(file), // Temporary URL for preview
        uploadDate: new Date().toLocaleString(),
        uploadedBy: 'Current User' // In real app, get from auth service
      };

      this.ticketAttachments.push(newAttachment);

      // Add to timeline
      const timelineEntry = {
        name: 'Current User',
        date: new Date().toLocaleString(),
        desc: `Uploaded file: ${file.name}`,
        type: 'attachment'
      };
      this.ticketTimeline = [...this.ticketTimeline, timelineEntry];
    }

    // Clear selected files and close dialog
    this.selectedFiles = [];
    this.showAddFileDialog = false;

    // Here you would upload files to server
    // this.uploadFilesToServer(this.selectedFiles);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }


  getFileName(url: string): string {
    return url.split('/').pop() || 'unknown';
  }

  getFileType(url: string): string {
    const ext = url.split('.').pop()?.toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext!)) return 'image';
    if (['mp4', 'mov', 'avi'].includes(ext!)) return 'video';
    if (ext === 'pdf') return 'pdf';
    return 'document';
  }

  viewAttachment(url: string) {
    window.open(url, '_blank');
  }

  async downloadAttachment(url: string) {
    try {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = this.getFileName(url);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed', error);
    }
  }


  files: { file: File, preview: string }[] = [];
  totalFiles: { file: File, preview: string }[] = [];
  uploadedUrls: string[] = [];
  loading = false;
  imgTitle = 'Upload Attachments';

  onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    const totalFiles = selectedFiles.length;
    let processedFiles = 0;

    if (totalFiles > 0) {
      this.files = [];
      this.totalFiles = [];

      for (let i = 0; i < totalFiles; i++) {
        const file = selectedFiles[i];
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.files.push({ file, preview: e.target.result });
          this.totalFiles.push({ file, preview: e.target.result });
          processedFiles++;

          if (processedFiles === totalFiles) {
            this.uploadImages();
          }
        };

        reader.readAsDataURL(file);
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No files selected for upload' });
    }
  }

  uploadImages() {
    if (this.files.length > 0) {
      this.loading = true;
      this.imgTitle = 'Uploading...';

      const uploadPromises = this.files.map((fileObj) => {
        const formData = new FormData();
        const folder = `public/hospital-001/$001/profile`;
        formData.append('file', fileObj.file);
        formData.append('folders', folder);
        formData.append('bucket', 'global-upload-storage');

        return this.uploadService.uploadDocuments(formData).toPromise();
      });

      Promise.all(uploadPromises)
        .then((responses) => {
          responses.forEach((res: any) => {
            if (res) {
              this.uploadedUrls.push(res.url);
            }
          });

          // Update form control with uploaded URLs
          this.ticket.attachments = [
            ...this.ticket.attachments,
            ...this.uploadedUrls
          ];
        })
        .catch((error) => {
          console.error('Error uploading images:', error);
          this.messageService.add({ severity: 'error', summary: 'Upload Error', detail: 'Failed to upload attachments' });
        })
        .finally(() => {
          this.loading = false;
          this.imgTitle = 'Upload Attachments';
        });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No files selected for upload' });
    }
  }

  removeFile(index: number) {
    this.totalFiles.splice(index, 1);
    this.uploadedUrls.splice(index, 1);

    this.ticket.patchValue({
      attachments: this.uploadedUrls
    });
  }

  saveAttachments() {
    this.ticket.updated_by = {
      name: this.localStorageService.getUserFullName(),
      user_id: this.localStorageService.getUserId(),
      email : this.localStorageService.getEmail()
    }
    this.savingAttachments = true;
    this.ticketService.updateTicket(this.ticket).subscribe({
      next: (response) => {
        this.savingAttachments = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Attachments updated successfully' });
        this.showAddFileDialog = false;
      },
      error: (error) => {
        this.savingAttachments = false;
        console.error('Error updating ticket attachments', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update attachments' });
      }
    });
  }

  onDialogClose() {
    // Cleanup if user closes dialog
    this.totalFiles = [];
    this.files = [];
    this.uploadedUrls = [];
    this.imgTitle = 'Upload Attachments';
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  }

  isVideo(file: string): boolean {
    return /\.(mp4|webm|ogg|mov)$/i.test(file);
  }

  isPDF(file: string): boolean {
    return /\.(pdf)$/i.test(file);
  }

}
